//import '../css/App.css';
import * as React from "react";
import {
  AdvancedMarker,
  APIProvider,
  Map,
  InfoWindow,
  useMap,
} from "@vis.gl/react-google-maps";
import PostMapLoc from "./postMapLoc";
import { IconContext } from "react-icons";
import { MdOutlineMyLocation } from "react-icons/md";

const PostMap = (props: any) => {
  const [allMarkers, setAllMarkers] = React.useState<[]>([]);
  const [activeMarker, setActiveMarker] = React.useState(null);
  const [globBounds, setGlobBounds] =
    React.useState<google.maps.LatLngBounds>();
  const [loading, setLoading] = React.useState(true);
  const [lat, setLat] = React.useState("0");
  const [lng, setLong] = React.useState("0");
  var myZoom = 10;

  const getCoords = async () => {
    const geolocAPI = navigator.geolocation;
    const pos = await new Promise((resolve, reject) => {
      geolocAPI.getCurrentPosition(
        (position: GeolocationPosition) => {
          setLat(position.coords.latitude.toString());
          setLong(position.coords.longitude.toString());
          resolve(position);
        },
        (err: GeolocationPositionError) => {
          console.error(err.code + " --- " + err.message);
          reject(err);
        }
      );
    });
    return pos;
  };

  const HandleOnLoad = (props: any) => {
    const map = useMap();

    React.useEffect(() => {
      if (!map) return;
      let bndChange: boolean = false;

      if (props.markers !== allMarkers.length) {
        //const bounds = new google.maps.LatLngBounds();
        const bounds = map.getBounds();

        allMarkers.forEach(({ lat, long }) => {
          let tmpLoc = { lat: parseFloat(lat), lng: parseFloat(long) };
          if (bounds?.contains(tmpLoc)) {
            console.log("in bounds");
          } else {
            if (globBounds?.contains(tmpLoc)) {
              console.log("in global bounds... don't change!");
            } else {
              bounds?.extend(new google.maps.LatLng(tmpLoc));
              bndChange = true;
            }
          }
        });
        if (bndChange) {
          console.log("bounds changed. extending...");
          map.fitBounds(bounds!);
          setGlobBounds(bounds);
        }
      } else {
        console.log("no new markers...", props.markers, allMarkers.length);
      }
    }, [props.markers]);

    return <></>;
  };

  const PoiMarkers = () => {
    const HandleActiveMarker = (marker: React.SetStateAction<null>) => {
      if (marker === activeMarker) {
        return;
      }
      setActiveMarker(marker);
    };

    return (
      <>
        {allMarkers.map((poi: any, index) => (
          <>
            {/*console.log(poi._id)*/}
            <AdvancedMarker
              key={poi._id}
              position={{ lat: parseFloat(poi.lat), lng: parseFloat(poi.long) }}
              clickable
              onClick={() => {
                HandleActiveMarker(poi._id);
              }}
              title={poi.name}
            >
              <div className="markers"></div>

              {activeMarker === poi._id ? (
                <InfoWindow
                  key={index}
                  disableAutoPan={false}
                  position={{
                    lat: parseFloat(poi.lat),
                    lng: parseFloat(poi.long),
                  }}
                  onCloseClick={() => setActiveMarker(null)}
                >
                  <div>
                    <b>{poi.name}:</b> {poi.body}
                  </div>
                </InfoWindow>
              ) : null}
            </AdvancedMarker>
          </>
        ))}
      </>
    );
  };

  const MyLoader = () => (
    <svg
      className="loader"
      version="1.1"
      id="L5"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      enableBackground="new 0 0 0 0"
    >
      <circle fill="blue" stroke="none" cx="6" cy="50" r="6">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 15 ; 0 -15; 0 15"
          repeatCount="indefinite"
          begin="0.1"
        />
      </circle>
      <circle fill="white" stroke="none" cx="30" cy="50" r="6">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 10 ; 0 -10; 0 10"
          repeatCount="indefinite"
          begin="0.2"
        />
      </circle>
      <circle fill="red" stroke="none" cx="54" cy="50" r="6">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 5 ; 0 -5; 0 5"
          repeatCount="indefinite"
          begin="0.3"
        />
      </circle>
    </svg>
  );

  const CenterControl = () => {
    const map = useMap();

    function useCenterControl() {
      if (!map) {
        console.log("no map");
      } else {
        map.panTo({ lat: parseFloat(lat), lng: parseFloat(lng) });
        console.log("center me");
      }
    }

    return (
      <IconContext.Provider value={{ color: "green", size: "1.25em" }}>
        <button
          onClick={useCenterControl}
          type="button"
          title="Find yourself"
          id="map-center-button"
        >
          <MdOutlineMyLocation />
        </button>
      </IconContext.Provider>
    );
  };

  React.useEffect(() => {
    getCoords();
    if (props.markers.length !== allMarkers.length) {
      setAllMarkers(props.markers);
      setLoading(false);
    }
  }, [allMarkers.length, props.markers]);

  return (
    //sportsman: AIzaSyCch_4Qf7jIB080t7bm0p61qGZrDREpy4A
    //commenter: AIzaSyDDtAn1RDrpELMp8ZGW5mIEtcMyWLmLpW0
    //onCameraChanged={ (ev = MapCameraChangedEvent) => console.log('camera changed:', ev.detail.center, 'zoom:', ev.detail.zoom) }
    <>
      {loading ||
      (lat === undefined && lng === undefined) ||
      (lat === "0" && lng === "0") ? (
        <>
          <div className="masterLoader">
            {
              MyLoader()
              //console.log(props.lat, props.long)
            }
          </div>
        </>
      ) : (
        <APIProvider
          apiKey={"AIzaSyCch_4Qf7jIB080t7bm0p61qGZrDREpy4A"}
          onLoad={() => {
            console.info("Maps API has loaded.");
          }}
        >
          <Map
            gestureHandling={"greedy"}
            defaultZoom={myZoom}
            defaultCenter={{ lat: parseFloat(lat), lng: parseFloat(lng) }}
            mapId={"b492275b098fb07d"}
            onClick={() => setActiveMarker(null)}
            zoomControl={false}
            controlSize={25}
          >
            <PoiMarkers />
            <PostMapLoc />
            <CenterControl />
          </Map>

          <HandleOnLoad markers={props.markers.length} />
        </APIProvider>
      )}
    </>
  );
};

export default PostMap;
